import React, { Component } from 'react';
import v from 'vudu';
import { styles as s } from 'stylesheet';
import moment from 'moment';
import Text from 'components/Text';
import leftpad from 'utils/leftpad';

// UTC is Four hours ahead of EDT & this date is zero indexed for months
const FINAL_DATE = moment.utc([2017, 10, 7, 3, 59, 59]);

const localClasses = v({
  navCountdown: {
    '@composes': [s.pr2],
    float: 'right',
    display: 'flex',
    alignItems: 'flex-end',
    paddingTop: '7px'
  },
  number: {
    '@composes': [s.ml1],
    display: 'inline-block',
    lineHeight: 1,
  },
  letter: {
    display: 'inline-block',
    lineHeight: '20px'
  }
});

export default class NavCountdown extends Component {
  state = {
    days:    '13',
    hours:   '23',
    minutes: '13',
    seconds: '54'
  }

  componentWillMount() {
    this.updateTimerState();
    setInterval(this.updateTimerState, 1000);
  }

  updateTimerState = () => {
    let duration = moment.duration(FINAL_DATE.diff(moment.utc()));
    this.setState({
      days:    leftpad(`${Math.floor(duration.asDays())}`, 2),
      hours:   leftpad(`${duration.hours()}`, 2),
      minutes: leftpad(`${duration.minutes()}`, 2),
      seconds: leftpad(`${duration.seconds()}`, 2)
    });
  }

  render() {
    const { color } = this.props;
    const { days, hours, minutes, seconds } = this.state;
    return (
      <div className={localClasses.navCountdown}>
        <Text variant={'countdownNumber'} classes={localClasses.number} color={color}>{days}</Text>
        <Text variant={'countdownLetter'} classes={localClasses.letter} color={color}>D</Text>

        <Text variant={'countdownNumber'} classes={localClasses.number} color={color}>{hours}</Text>
        <Text variant={'countdownLetter'} classes={localClasses.letter} color={color}>H</Text>

        <Text variant={'countdownNumber'} classes={localClasses.number} color={color}>{minutes}</Text>
        <Text variant={'countdownLetter'} classes={localClasses.letter} color={color}>M</Text>

        <Text variant={'countdownNumber'} classes={localClasses.number} color={color}>{seconds}</Text>
        <Text variant={'countdownLetter'} classes={localClasses.letter} color={color}>S</Text>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/NavCountdown.js